import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ApIcon, colors } from '@alixpartners/ui-components';
import { Row, Wrapper, Label } from './FileListDownload.styles';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import FileLisTable from './FileListTable';
import { daleteVendorFiles } from 'utils/apiRequests';

export const FileListDownload = ({
	data,
	isVendorFetching,
	fetchFileArchive,
}) => {
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [isDeleting, setIsDeleting] = useState(false);
	if (data.length === 0) {
		return (
			<>
				{isVendorFetching ? (
					<Wrapper>
						<ApLoaderDefault />
					</Wrapper>
				) : (
					<Wrapper>
						<Row>
							<ApIcon iconName="cloud_upload" iconColor={colors.grey8} />
							<Label>No data uploaded</Label>
						</Row>
					</Wrapper>
				)}
			</>
		);
	}

	const onRowSelected = params => {
		let fileId = [];
		const selectedData = params.api.getSelectedRows();
		selectedData.forEach(element => {
			fileId.push(element.id);
		});
		setSelectedFiles(fileId);
	};

	const deleteFiles = () => {
		setIsDeleting(true);
		daleteVendorFiles(selectedFiles)
			.then(res => {
				if (res.isDeleted) {
					fetchFileArchive();
					setIsDeleting(false);
					setSelectedFiles([]);
				}
			})
			.catch(() => {
				setIsDeleting(false);
			});
	};

	return (
		<>
			{isVendorFetching ? (
				<Wrapper>
					<ApLoaderDefault />
				</Wrapper>
			) : (
				<Wrapper>
					{isDeleting ? (
						<Wrapper>
							<ApLoaderDefault />
						</Wrapper>
					) : (
						<FileLisTable
							normalizedFiles={data}
							selectedFiles={selectedFiles}
							onRowSelected={onRowSelected}
							onDelete={deleteFiles}
						/>
					)}
				</Wrapper>
			)}
		</>
	);
};

FileListDownload.propTypes = {
	data: PropTypes.arrayOf(PropTypes.object),
	isVendorFetching: PropTypes.bool,
};

FileListDownload.defaultProps = {
	data: [],
};

export default FileListDownload;
